
import { AXNUIFormHelpTextContainer } from "@iddataweb/idw-common-ui/containers";
import { ThemingGenericContentSlotTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContent, AXNUILayout, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { getAXNUILayoutHelpTextParameters } from "@iddataweb/idw-common-ui/utils";

import { useMemo } from "react";

type AXNUIThemingPreFormHelpTextContainerProps = {
    axnuiContent: AXNUIContent;
    axnuiLayout: AXNUILayout;
    axnuiTheme: AXNUITheme;
};

export const AXNUIThemingPreFormHelpTextContainer = (props: AXNUIThemingPreFormHelpTextContainerProps) => {
    const { axnuiContent, axnuiLayout, axnuiTheme } = props;

    const helpTextParameters = useMemo(()=> {
        return getAXNUILayoutHelpTextParameters(axnuiContent, axnuiLayout, ThemingGenericContentSlotTypes.PRE_FORM_HELP_TEXT);
   }, [axnuiLayout.helpText.preformHelpText, axnuiContent]);

    return (
        <AXNUIFormHelpTextContainer
            parameters={helpTextParameters}
            id={ThemingGenericContentSlotTypes.PRE_FORM_HELP_TEXT}
            content={axnuiContent}
            isSubmitting={false}
            explicitConsentChecked={false}
            setExplicitConsentChecked={() => {}}
            textColor={axnuiTheme.general.mainTextColor}
            fontFamily={axnuiTheme.general.font}
            buttonTextColor={axnuiTheme.general.mainButtonTextColor}
            buttonBackgroundColor={axnuiTheme.general.mainButtonBackgroundColor}
            linksColor={axnuiTheme.general.linksColor}
        />
    );
};